var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"captcha"},[_vm._v(" captcha "),_c('br'),_vm._v(" "+_vm._s(_vm.options)+" "),_c('br'),_c('el-button',{attrs:{"type":"danger","size":"small"},on:{"click":_vm.checkCaptcha}},[_vm._v("关闭验证码")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }